<template>
    <div class="card-modal__preview row">
        <div class="card-modal__title">One last check</div>
        <div class="card-modal__subtitle mb-4">
            Creating a Card Deck sends it to your private collection in 'My Card Decks'. From there, you can choose whether to share it with a Hero, or with the broader community.
        </div>
        <div class="d-flex flex-row justify-content-center gap-3">
            <div class="d-flex flex-column">
                <div class="card-modal__card-preview">
                    <img v-if="selectedCard.image" :src="selectedCard.image">
                    <img v-else src="/assets/img/backgrounds/no-image-background.svg">
                </div>
                <div class="d-flex flex-row mt-2 gap-2 align-items-center">
                    <div class="card-deck-card__counter-label">
                        {{!cardDeck.central_image && selectedCard.sort_by === 1 ? 'Cover' : 'Card ' + selectedCard.sort_by}}
                    </div>
                    <div class="card-modal__description d-flex">{{ selectedCard.description }}</div>
                </div>
            </div>
            <div class="d-flex flex-column" style="max-height: 550px; width: 130px; min-width: 130px; overflow: hidden">
                <VuePerfectScrollbar>
                    <div class="card-deck-card"
                         :class="{'selected': card === selectedCard}"
                         @click="selectCard(card)"
                         v-for="(card, index) in cardDeck.cards">
                        <img v-if="card.image" :src="card.image">
                        <img v-else src="/assets/img/backgrounds/no-image-background.svg">
                        <div class="card-deck-card__counter-label floating" :class="{'selected': card === selectedCard}">
                            {{ !cardDeck.central_image && index === 0 ? 'Cover' : 'Card ' + (index + 1) }}
                        </div>
                    </div>
                </VuePerfectScrollbar>
            </div>
        </div>
    </div>
</template>

<script>
import Card from "@/components/Card.vue"
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
    name: "CardDeckPreview",
    components: {Card, VuePerfectScrollbar},
    props: ['cardDeck'],
    data() {
        return {
            cards: [],
            selectedCard: {},
        }
    },
    mounted() {
        if (this.cardDeck.cards) {
            this.selectedCard = this.cardDeck.cards[0];
        }
    },
    methods: {
        selectCard(card) {
            this.selectedCard = card;
        },
    }
}
</script>

<style>

</style>
